import { FETCH_NOTIFICATIONS, SHOW_NOTIFICATION } from './ActionType'
import axios from 'axios'
import apiConfig from '../../../config/apiConfig'

// Action creator to show a notification
export function showNotification(isShown, message, variant) {
  return {
    type: SHOW_NOTIFICATION,
    payload: {
      isShown, // Boolean: whether to show the notification
      message, // String: notification message
      variant, // String: notification type (e.g., 'success', 'error')
    },
  }
}

export const fetchNotification = ({
  size,
  from,
  start,
  filter,
  isNationalBrand,
}) => {
  return async (dispatch) => {
    try {
      // Ensure isNationalBrand is a boolean
      const isTargetPlusVendor = isNationalBrand
        ? Boolean(isNationalBrand)
        : false

      let url = `${apiConfig.notification.notifications}?app=GGA&start=${start}&size=${size}&is_target_plus_vendor=${isTargetPlusVendor}`

      if (from) {
        url += `&delta_timestamp=${from}`
      }

      if (filter && filter !== 'all') {
        url += `&notification_type=${filter}`
      }

      let response = await axios.get(url)

      dispatch({
        type: FETCH_NOTIFICATIONS,
        payload: {
          notifications: response?.data || { data: [], total: 0 },
        },
      })
    } catch (error) {
      console.error('Error fetching notifications:', error)
      dispatch({
        type: FETCH_NOTIFICATIONS,
        payload: {
          notifications: { data: [], total: 0 },
        },
      })
    }
  }
}

export const markASread = ({ notification_ids, isNationalBrand }) => {
  return async (dispatch) => {
    try {
      // Ensure isNationalBrand is a boolean
      const isTargetPlusVendor = Boolean(isNationalBrand)

      const data = {
        notification_ids: notification_ids,
        mark_as: 'READ',
      }

      let response = await axios.put(
        `${apiConfig.notification.notifications}?is_target_plus_vendor=${isTargetPlusVendor}`,
        data
      )
      if (response.status === 200) {
        // Don't automatically refetch here - let the hook handle it
        return response
      } else {
        dispatch(
          showNotification(true, 'Failed to mark notification as read', 'error')
        )
      }
    } catch (error) {
      console.error('Error marking notification as read:', error)
      dispatch(
        showNotification(true, 'Failed to mark notification as read', 'error')
      )
    }
  }
}
